export enum EnumCurrency {
    EUR ='EUR'
}